import * as React from "react";
import { createStyles, Theme, withStyles } from "@material-ui/core";
import PrescriptionIngestionSection from "../PrescriptionIngestionSection";

const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginLeft: spacing(4),
      marginRight: spacing(4),
      marginTop: spacing(4),
    },
  });

const Page = (props: any) => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <PrescriptionIngestionSection />
    </div>
  );
};

export default withStyles(styles)(Page);
